export const SUBSCRIPTION_PLANS = Object.freeze({
  ESSENTIAL: "essential",
  PERFORMANCE: "performance",
  COACHING: "coaching",
});

const PLAN_LABELS = Object.freeze({
  [SUBSCRIPTION_PLANS.ESSENTIAL]: "Essentiel",
  [SUBSCRIPTION_PLANS.PERFORMANCE]: "Performance",
  [SUBSCRIPTION_PLANS.COACHING]: "Coaching",
});

export const normalizeSubscriptionPlan = (value) => {
  const normalized = String(value || "").trim().toLowerCase();
  return Object.values(SUBSCRIPTION_PLANS).includes(normalized) ? normalized : null;
};

export const getSubscriptionPlanLabel = (value) =>
  PLAN_LABELS[normalizeSubscriptionPlan(value)] || "Non défini";

export const getSubscriptionCapabilities = (account) =>
  account?.capabilities && typeof account.capabilities === "object"
    ? account.capabilities
    : {};

export const hasSubscriptionCapability = (account, capability) =>
  getSubscriptionCapabilities(account)[capability] === true;
